<template>
  <div>
    <b-button size="sm" variant="success" v-b-modal.modal-1>New User</b-button>
    <b-modal id="modal-1" title="Register New User">
      <b-alert variant="success" v-if="success" show> {{ success }}</b-alert>
      <b-alert variant="danger" v-if="error" show> {{ error }}</b-alert>

      <b-form @submit.prevent="submitForm">
        <b-form-group id="input-group-1" label="Full Name:" label-for="input-1">
          <ValidationProvider rules="required" v-slot="{ errors }">
            <b-form-input
              id="input-1"
              v-model="form.name"
              type="text"
              placeholder="Enter Full Name"
              required
            ></b-form-input>
            <span class="error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-form-group>

        <b-form-group id="input-group-2" label="Email:" label-for="input-2">
          <ValidationProvider rules="email" v-slot="{ errors }">
            <b-form-input
              id="input-2"
              v-model="form.email"
              placeholder="Enter Email"
              required
            ></b-form-input>
            <span class="error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-form-group>

        <b-form-group id="input-group-2" label="Phone:" label-for="input-2">
          <ValidationProvider rules="phone:10" v-slot="{ errors }">
            <b-form-input
              id="input-2"
              v-model="form.phone"
              placeholder="Enter Phone"
              required
            ></b-form-input>
            <span class="error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Date of Birth:"
          label-for="input-1"
        >
          <ValidationProvider rules="required" v-slot="{ errors }">
            <b-input-group>
              <b-form-input
                id="example-input"
                v-model="tempDOB"
                type="text"
                placeholder="DD-MM-YYYY"
                autocomplete="off"
              ></b-form-input>
            </b-input-group>
            <span class="error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-form-group>

        <b-form-group id="input-group-2" label="Password:" label-for="input-2">
          <ValidationProvider rules="required" v-slot="{ errors }">
            <b-form-input
              id="input-2"
              v-model="form.password"
              placeholder="Enter Password"
              required
            ></b-form-input>
            <span class="error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-form-group>

        <b-form-group id="input-group-2" label="User Type:" label-for="input-2">
          <ValidationProvider rules="required" v-slot="{ errors }">
            <b-form-select
              v-model="form.user_type"
              :options="options"
              value-field="name"
              text-field="name"
            ></b-form-select>
            <span class="error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-form-group>

        <b-form-group
          id="input-group-2"
          label="Member Since:"
          label-for="input-2"
        >
          <ValidationProvider rules="required" v-slot="{ errors }">
            <b-form-datepicker
              id="example-datepicker2"
              v-model="form.member_since"
              class="mb-2"
            ></b-form-datepicker>
            <span class="error">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-form-group>
      </b-form>

      <template #modal-footer="{ close }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button
          id="toggle-btn"
          size="sm"
          variant="success"
          @click="submitForm()"
        >
          Register
        </b-button>
        <b-button size="sm" variant="danger" @click="close()"> Close </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      form: {
        name: "",
        email: "",
        phone: "",
        user_type: "",
        member_since: "",
        password: "",
        dob: "",
      },
      options: [],
      success: false,
      error: false,
      tempDOB: "",
    };
  },

  mounted() {
    this.getUserType();
  },
  methods: {
    getUserType() {
      window.axios.get("user-types").then((resp) => {
        this.options = resp.data;
      });
    },
    submitForm() {
      if (this.tempDOB.length === 10) {
        // reset previous messages
        this.success = false;
        this.error = false;

        this.form.dob = moment(this.tempDOB, "DD-MM-YYYY").format("YYYY-MM-DD");
        window.axios
          .post("users", this.form)
          .then((resp) => {
            if (resp.data.success) {
              this.success = resp.data.message;
              this.form.name = "";
              this.form.email = "";
              this.form.user_type = "";
              this.form.phone = "";
              this.form.member_since = "";
              this.form.password = "";
              this.form.dob = "";
              this.tempDOB = "";

              setTimeout(() => {
                this.success = false;
                this.$emit("user-create", resp.data);
              }, 3000);
            }
          })
          .catch((error) => {
            if (error.response && error.response.status >= 400) {
              this.error =
                (error.response.data && error.response.data.message) ||
                "An error occurred while creating the user.";
            } else {
              this.error =
                "A network or server error occurred while creating the user.";
            }
          });
      } else {
        window.alert("Date of Birth field is invalid!");
      }
    },
  },
};
</script>
